/**
 * Loop trough each "flat" property of the current step (usually 0) and create a Map with a "path" and trigger with pure values
 * @param {TriggerMapProps} trigger
 * @param {MainClassProps} main
 * @param {StepProps} step
 */
const setActiveProperties = (trigger, main, step) => {
  /** Trigger name */
  const name = trigger.get("name");

  /** A step "flat" map with all flat properties used in the step */
  const flat = /** @type {Array<PureValueMapProps>} */ (
    step.get("flat")
  );

  const actives = main.activeProperties;

  /** Loop trough each value of the step's "flat" map */
  for (const value of flat) {
    /** Get the path in the `transform>N:translateX>:>L:0(,)>0( )>0(,)>0( )` format */
    const path = /** @type {String} */ (value.get("path"));

    /** Name of the parent wrapper (transform) */
    const parent =  /** @type {String} */ (value.get("parent"));

    /** Named function name (`scale`) or default (`0`) */
    const fn = value.get("fn");

    /** Property data */
    const data = /** @type {StorageItemDataProps} */ (value.get("property-data"));

    const order = value.get("o_order");

    /** Priority */
    const priority = data.get("priority");

    if (!actives.has(parent)) {
      actives.set(parent, new Map());
    }

    if (!actives.get(parent).has(fn)) {
      actives.get(parent).set(fn, [new Map(), priority, 1, order]);
    }

    /** If the `activeProperties` of `main` object does not have a current flat value */
    if (!actives.get(parent).get(fn)[0].has(path)) {
      actives.get(parent).get(fn)[0].set(path, new Map());
    }

    /**
     * Set trigger and the pure value to the "path"
     * @example `transform>N:scale>:>L:0(,)>0( )>0(,)>0( ) => Map(2) {'animate_[[t-ati-s>]' => Map(24), 'animate_sca-(44-s>)' => Map(24)}`
     */
    actives.get(parent).get(fn)[0].get(path).set(name, value);
  }
};

export default setActiveProperties;
